export default __webpack_public_path__ + "60fbbe26012cbb851b1b54f5f529fecd.png";